import { useState } from "react";
import { Collapse } from "@mui/material";
import CompanyRow from "../CertificateTable/CompanyRow";

import classes from './index.module.scss';
import MaterialRow from "../CertificateTable/MaterialRow";

const CompanyRowsContainer = ({ company, showCompanyRow, showCompanyLink, isApproved, isPremium }) => {
  const [isOpened, setOpened] = useState(!showCompanyRow);

  const onClick = () => {
    setOpened(!isOpened);
  }

  const materialBasedList = [
    // make sure without a material will be the first
    {
      name: '',
      productList: [],
    }
  ];

  company.productList.forEach((product) => {
    const materialName = (product.material?.name || '');

    let foundList = materialBasedList.find((material) => material.name === materialName);

    if (!foundList) {
      foundList = {
        name: materialName,
        productList: [],
      };

      materialBasedList.push(foundList)
    }

    foundList.productList.push(product);
  })

  return (
    <>
      {
        showCompanyRow ? <CompanyRow company={company} showCompanyLink={showCompanyLink} onClick={onClick} isOpened={isOpened} /> : null
      }
      <Collapse in={isOpened} className={classes.collapsibleContainer}>
        {
          materialBasedList.map((material) => {
            return (
              <MaterialRow
                key={material.name}
                material={material}
                isApproved={isApproved}
                isPremium={isPremium}
              />
            )
          })
        }
      </Collapse>
    </>
  )
}

export default CompanyRowsContainer;